import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-20" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createVNode(_component_RouterView)
      ])
    ]),
    _createVNode(_component_AppFooter)
  ]))
}